export default __webpack_public_path__ + "h13.png";